



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { DeriveTreasuryProposals } from '@polkadot/api-derive/types';
import Summary from './Summary.vue'
import ItemCard from '@/components/shared/wrapper/ItemCard.vue'
import Money from '@/components/shared/format/Money.vue'
import WithLabel from '@/components/shared/format/WithLabel.vue'

import Connector from '@vue-polkadot/vue-api';

@Component({
  components: {
    Summary,
    ItemCard,
    Money,
    WithLabel
  }
})
export default class Proposal extends Vue {
  @Prop() proposal!: any;

}
